"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Flag = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _Flag = _interopRequireDefault(require("./Flag.styles"));

var _flags = _interopRequireDefault(require("./flags.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(_objectSpread({}, (0, _Flag.default)(_flags.default)));

var Flag = function Flag(_ref) {
  var country = _ref.country;
  var classes = useStyles();
  var inputFlagClasses = "flag ".concat(country, " ").concat(classes.flag);
  return _react.default.createElement("div", {
    className: inputFlagClasses
  });
};

exports.Flag = Flag;